import React from 'react'
import '../../assets/scss/pages/notFound.scss'
import { Link } from 'react-router-dom'

const NotFound = () => {
    return (
        <div className='body'>
            <section id="not-found">
                <div id="title">Simple Pure CSS3 &bull; 404 Error Page</div>
                <div className="circles">
                    <p>404<br />
                        <small>PAGE NOT FOUND</small>
                    </p>
                    <span className="circle big"></span>
                    <span className="circle med"></span>
                    <span className="circle small"></span>
                </div>
            </section>
            <div className='back-to-home-btn'>
                <Link to='/'>Go to home page</Link>
            </div>
        </div>
    )
}

export default NotFound